import { Avatar, Box, Center, Flex, Grid, Icon } from '@chakra-ui/react';
import { Recording01 } from '@kula-ai/icons/dual-tone/Recording01';
import { InterviewItem as InterviewItemType } from '../../types';
import { IconText } from '../IconText';
import { MarkerPin01 } from '@kula-ai/icons/dual-tone/MarkerPin01';
import { LayersThree02 } from '@kula-ai/icons/dual-tone/LayersThree02';
import { Clock } from '@kula-ai/icons/dual-tone/Clock';
import { Gmeet, Teams, Zoom } from '@/assets/icons/location';
import { PhoneCall01 } from '@kula-ai/icons/dual-tone/PhoneCall01';
// import { SearchItemWrapper } from './SearchItemWrapper';
import { Link } from 'react-router-dom';
// import { useSearchManager } from '../search-manager';
// import { HighlightedTooltipText } from '../text';
import { useDateFormat } from '@/hooks';
import { Hackerrank } from '@/assets/icons/ats';
import { useEffect, useRef } from 'react';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import { capitalizeFirstLetter } from '@/utils/commonHelpers';
import moment from 'moment';

interface InterviewItemProps {
  item: InterviewItemType;
  isSelected?: boolean;
  onSearchClose?: () => void;
}

const locationIconMap = {
  zoom: { icon: Zoom },
  google_meet: { icon: Gmeet },
  phone_interview: { icon: PhoneCall01 },
  onsite: { icon: MarkerPin01 },
  teams: { icon: Teams },
  hackerrank: { icon: Hackerrank },
};

export const InterviewItem = ({
  item,
  isSelected,
  onSearchClose,
}: InterviewItemProps) => {
  const itemRef = useRef<HTMLAnchorElement>(null);
  const { start_time, id, location, candidate_name, job_name, interview_name } =
    item;
  const { dateFormat, timeFormat } = useDateFormat();

  const dateTimeFormat = `${dateFormat.label}, ${timeFormat}`;

  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.scrollIntoView({ block: 'nearest' });
    }
  }, [isSelected]);

  return (
    <Link
      to={`/interviews/${id}`}
      style={{ textDecoration: 'none' }}
      ref={itemRef}
      onClick={() => onSearchClose?.()}
    >
      {/* <SearchItemWrapper> */}
      <Flex
        alignItems="center"
        gap="12px"
        className="ai-search-interview-item"
        p="12px"
        _hover={{
          backgroundColor: 'secondary-50',
        }}
        backgroundColor={isSelected ? 'secondary-50' : undefined}
      >
        <Center
          width="36px"
          height="36px"
          borderRadius="xs"
          bg="pastel-3-light"
        >
          <Icon
            as={Recording01}
            color="pastel-3-dark"
            width="1rem"
            height="1rem"
          />
        </Center>
        <Flex flexDirection="column" gap="3px" flex="1">
          <Flex gap="6px">
            <TruncatedTextWithTooltip
              color="secondary-900"
              variant="heading_3"
              text={capitalizeFirstLetter(interview_name)}
              enableTooltip={true}
              maxWidth="900px"
            />
          </Flex>
          <Grid
            templateColumns="fit-content(90%) fit-content(90%) fit-content(20%) fit-content(20%)"
            gap="12px"
            alignItems="center"
            width="100%"
            minW={0}
          >
            {candidate_name && (
              <Flex gap="6px" alignItems="center" minW={0}>
                <Avatar
                  // src={candidate_name}
                  name={candidate_name}
                  width="16px"
                  height="16px"
                  borderRadius="2px"
                  className="avatar-xs"
                />
                <TruncatedTextWithTooltip
                  color={'secondary-900'}
                  variant="heading_4"
                  text={capitalizeFirstLetter(candidate_name)}
                  enableTooltip={true}
                  maxWidth="250px"
                />
              </Flex>
            )}
            {job_name && (
              <Box minW={0}>
                <IconText
                  icon={LayersThree02}
                  text={job_name}
                  textProps={{ maxW: '100%' }}
                  // highlight={job_name}
                />
              </Box>
            )}
            {start_time && (
              <Box minW={0}>
                <IconText
                  icon={Clock}
                  text={moment.unix(start_time).format(dateTimeFormat)}
                  textProps={{ maxW: '100%' }}
                />
              </Box>
            )}
            {location && location !== 'unspecified' && (
              <Box minW={0}>
                <IconText
                  icon={locationIconMap[location].icon}
                  text={location?.replace('_', ' ')}
                  textProps={{ textTransform: 'capitalize', maxW: '100%' }}
                />
              </Box>
            )}
          </Grid>
        </Flex>
      </Flex>
      {/* </SearchItemWrapper> */}
    </Link>
  );
};
